var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_568_212)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4743 0.526207C10.1627 0.215088 9.74037 0.0403442 9.30004 0.0403442C8.85972 0.0403442 8.43739 0.215088 8.12579 0.526207L0.671458 7.98054C0.457989 8.19281 0.288732 8.4453 0.173478 8.7234C0.0582232 9.00151 -0.000740035 9.29971 -7.63001e-07 9.60075V10.5417C-7.63001e-07 10.6633 0.0482878 10.7798 0.134242 10.8658C0.220196 10.9518 0.336775 11 0.458333 11H1.39929C1.70031 11.0009 1.9985 10.942 2.27661 10.8268C2.55472 10.7117 2.80722 10.5425 3.0195 10.329L10.4743 2.87425C10.7853 2.56267 10.9599 2.14044 10.9599 1.70023C10.9599 1.26001 10.7853 0.837784 10.4743 0.526207ZM2.37142 9.68096C2.11292 9.93774 1.76365 10.0823 1.39929 10.0834H0.916666V9.60075C0.916202 9.42012 0.951571 9.2412 1.02072 9.07433C1.08988 8.90746 1.19144 8.75597 1.31954 8.62862L6.97675 2.97142L8.03092 4.02558L2.37142 9.68096ZM9.82575 2.22617L8.67717 3.37521L7.623 2.32333L8.77204 1.17429C8.84126 1.10522 8.9234 1.05047 9.01378 1.01314C9.10416 0.975823 9.20101 0.956669 9.29879 0.956775C9.39657 0.956881 9.49337 0.976246 9.58367 1.01376C9.67397 1.05128 9.75599 1.10622 9.82506 1.17544C9.89413 1.24465 9.94889 1.3268 9.98621 1.41718C10.0235 1.50756 10.0427 1.6044 10.0426 1.70218C10.0425 1.79997 10.0231 1.89677 9.98559 1.98707C9.94807 2.07737 9.89313 2.15939 9.82392 2.22846L9.82575 2.22617Z",
    fill: "#B0AFAF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_568_212"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.8cd5d832c33804d8b70758217a55b54d.svg";
export { ForwardRef as ReactComponent };